import { render, staticRenderFns } from "./AppPromo.vue?vue&type=template&id=7231d978&scoped=true"
import script from "./AppPromo.vue?vue&type=script&lang=js"
export * from "./AppPromo.vue?vue&type=script&lang=js"
import style0 from "./AppPromo.vue?vue&type=style&index=0&id=7231d978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7231d978",
  null
  
)

export default component.exports